export enum SynchronizationEvent {
    FEATURE_LIST_UPDATED = 'FEATURE_LIST_UPDATED',
    USER_UPDATED = 'USER_UPDATED',
    ROLE_LIST_UPDATED = 'ROLE_LIST_UPDATED',
    ROLE_UPDATED = 'ROLE_UPDATED',
}

